import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { TodosService } from './services/todos.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as $ from 'jquery';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(private todosService: TodosService, public http: HttpClient) {

  }

  faBars = faBars;
  faSearch = faSearch;
  title = 'angular-agm';

  region: boolean = false;
  clickEvent(){
    this.region = !this.region;       
  } 

  ngOnInit() {
    // this.todosService.login('opendata', 'open_pass_bcrypt_data');
    this.todosService.login('dim', 'PASSWORD');
  }

}
